import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class CustomerService extends Service {
    constructor() {
        super();
        this.baseURL = 'security/customer';
    }

    async findAll() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/all", {
            headers: {'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findAddressesOfUser(userId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/address/user/"+userId, {
            headers: {'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findByAddressId(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/address/"+id, {
            headers: {'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }



}